import React from 'react';
import { injectIntl } from 'react-intl-next';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { CheckboxModal } from './CheckboxModal';
import { SimpleModal } from './SimpleModal';
var ConfirmationModalImpl = function ConfirmationModalImpl(props) {
  var options = props.options;
  var renderModel = function renderModel() {
    var isReferentialityDialog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (
      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
      isReferentialityDialog ? /*#__PURE__*/React.createElement(CheckboxModal, props) : /*#__PURE__*/React.createElement(SimpleModal, props)
    );
  };
  return options ? /*#__PURE__*/React.createElement(ModalTransition, null, renderModel(options === null || options === void 0 ? void 0 : options.isReferentialityDialog)) : null;
};
export var ConfirmationModal = injectIntl(ConfirmationModalImpl);